import moment from "moment-timezone";

export const setProvideScheduleStartDate = ({ startDate }) =>
  sessionStorage.setItem("provideScheduleStartDate", startDate.toISOString());

export const getProvideScheduleStartDate = () => {
  const date = sessionStorage.getItem("provideScheduleStartDate");
  return date ? moment(date) : null;
};

export const removeProvideScheduleStartDate = () =>
  sessionStorage.removeItem("provideScheduleStartDate");

export const setProvideScheduleFilters = ({ id, filters }) =>
  localStorage.setItem(`psFilters-${id}`, JSON.stringify(filters));

export const setProvideScheduleSortOption = ({ id, sortOption }) =>
  localStorage.setItem(`psSortOption-${id}`, sortOption);

export const getProvideScheduleSortOption = ({ id, sortOption }) =>
  localStorage.getItem(`psSortOption-${id}`, sortOption);

export const getProvideScheduleFilters = ({ id }) => {
  const filters = JSON.parse(localStorage.getItem(`psFilters-${id}`));

  if (filters) {
    // these fields have been removed from the filters
    delete filters.memberTypeFilter;
    delete filters.memberTypeFilter;
  }

  return filters;
};

export const setReservedBookingModalPreference = ({ id, preference }) =>
  localStorage.setItem(`reservedBookingPreference-${id}`, preference);

export const getReservedBookingModalPreference = ({ id }) =>
  localStorage.getItem(`reservedBookingPreference-${id}`);
